import ApiService from "@/core/services/api.service";

// action types
export const GET_PRICES = "getPrices";
export const STORE_GIFT_CARDS = "storeGiftCards";
export const FETCH_APP_PRICES = "GetAppPrices";
export const STORE_APP_PRICES = "storeAppPrices";
export const FETCH_COMPANY_PRICES = "fetchCompanyPrices";
export const FETCH_ADMIN_COMPANY_PRICES = "fetchAdminCompanyPrices";
export const STORE_ADMIN_COMPANY_PRICES = "storeAdminCompanyPrices";

// mutation types
export const SET_PRICES = "setPrices";
export const SET_APP_PRICES = "setAppPrices";
export const SET_COMPANY_PRICES = "setCompanyPrices";
export const SET_ADMIN_COMPANY_PRICES = "setCompaniesPagination";

const state = {
  prices: [],
  appPrices: [],
  companyPrices: [],
  adminCompanyPrices: []
};

const getters = {
  prices(state) {
    return state.prices;
  },
  appPrices(state) {
    return state.appPrices;
  },
  companyPrices(state) {
    return state.companyPrices;
  },
  adminCompanyPrices(state) {
    return state.adminCompanyPrices;
  }
};

const actions = {
  [GET_PRICES](context) {
    if (context.state.prices.length === 0) {
      return new Promise(resolve => {
        ApiService.get("prices", "", false)
          .then(({ data }) => {
            context.commit(SET_PRICES, data);
            resolve(data);
          })
          .catch(() => {
            // reject(response);
          });
      });
    }
  },
  [STORE_GIFT_CARDS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("gift-cards", payload, {}, false)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_APP_PRICES](context) {
    return new Promise(resolve => {
      ApiService.get("admin/prices")
        .then(({ data }) => {
          context.commit(SET_APP_PRICES, data);
          resolve(data);
        })
        .catch(e => void e);
    });
  },
  [STORE_APP_PRICES](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("admin/prices", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_COMPANY_PRICES](context, id) {
    return new Promise(resolve => {
      ApiService.get("company/prices", id)
        .then(({ data }) => {
          context.commit(SET_APP_PRICES, data);
          resolve(data);
        })
        .catch(e => void e);
    });
  },
  [FETCH_ADMIN_COMPANY_PRICES](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(`admin/companies/${id}/prices`, {})
        .then(({ data }) => {
          context.commit(SET_ADMIN_COMPANY_PRICES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_ADMIN_COMPANY_PRICES](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`admin/companies/${payload.id}/prices`, payload.form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_PRICES](state, data) {
    state.prices = data;
  },
  [SET_APP_PRICES](state, data) {
    state.appPrices = data;
  },
  [SET_COMPANY_PRICES](state, data) {
    state.companyPrices = data;
  },
  [SET_ADMIN_COMPANY_PRICES](state, adminCompanyPrices) {
    state.adminCompanyPrices = adminCompanyPrices;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
